const has = (perms, p) => perms.includes(p);
const hasAny = (perms, list = []) => list.some((p) => has(perms, p));

export function filterMenusByPermission(menus, perms = []) {
  return (menus || [])
    .map((item) => {
      const filteredChildren = item.children?.length
        ? filterMenusByPermission(item.children, perms)
        : [];

      const allowedBySelf =
        item.permission ? has(perms, item.permission)
        : item.anyOf?.length ? hasAny(perms, item.anyOf)
        : true;

      // keep parent if it is allowed OR any child is allowed
      const allowed = allowedBySelf || filteredChildren.length > 0;

      if (!allowed) return null;

      return { ...item, children: filteredChildren };
    })
    .filter(Boolean);
}
